import { styled } from '@mui/material/styles';
import { Button } from './StyledButton';

export const StyledRegisterButton = styled(Button)(({ theme }) => ({
	padding: theme.spacing(1.5),
	borderRadius: theme.shape.borderRadius,
	fontWeight: 500,
	textTransform: 'none',
	marginTop: theme.spacing(1),
	marginBottom: theme.spacing(1),
	color: theme.palette.text.primary,
	backgroundColor: theme.palette.background.paper,
	border: `1px solid ${theme.palette.divider}`,
	justifyContent: 'flex-start',
	'&:hover': {
		backgroundColor: theme.palette.action.hover
	}
}));
